export default __webpack_public_path__ + "static/media/membercard2.1de35dbb.png";